import React, { useEffect, useState } from "react";
import client, { formatApiError } from "@/lib/api";
import SchoolNotices from "@/components/SchoolNotices";

export default function PrincipalNotices() {
  const [schoolId, setSchoolId] = useState(null);
  const [err, setErr] = useState("");

  useEffect(() => {
    client.get("/principal/overview")
      .then(({ data }) => setSchoolId(data.school?.id || null))
      .catch((ex) => setErr(formatApiError(ex.response?.data?.detail) || ex.message));
  }, []);

  if (err) return <div className="hv-card p-7 text-hv-coral" data-testid="principal-notices-error">{err}</div>;
  if (!schoolId) return <div className="p-6 text-hv-slate">Loading…</div>;
  return <SchoolNotices schoolId={schoolId} />;
}
